import React from 'react';
import { Portal } from 'react-portal';
import { ThemeProvider, useTheme } from 'styled-components';

import { ATTACHMENTS } from 'newJs/config';
import { useAttachsParams } from 'providers/attachs-params';
import { useAttachsState } from 'providers/attachs-state';
import AttachmentsGrid from './Grid';
import AttachmentsInline from './List/Inline';
import ErrorBoundary from 'newJs/errorBoundary';
import InxToolTip from 'containers/Attachments/ToolTip';
import Overlay from 'containers/Overlay';

const { VIEW_MODE } = ATTACHMENTS;

export default function AttachmentsPanel(props) {
    // console.log(props);
    const { currentBreakpoint, currentViewMode, isPreviewMode } = useAttachsState();
    const { tooltipComponentId } = useAttachsParams();
    const { panel = {} } = useTheme();
    const panelTheme = {
        currentViewMode,
        data: currentBreakpoint && currentBreakpoint.data || {},
        panel: {
            ...panel,
            width: currentBreakpoint?.data?.panelWidth || 'auto',
        }
    };

    return (
        <ErrorBoundary render={(error, errorInfo) => (
            <p>{error}<br />{errorInfo}</p>
        )}>
            <ThemeProvider theme={panelTheme}>
                {currentViewMode === VIEW_MODE.GRID
                    ? (
                        <Portal>
                            <Overlay {...(isPreviewMode() && { zIndex: 999 })}>
                                <AttachmentsGrid />
                                {!isPreviewMode() && <InxToolTip id={tooltipComponentId} />}
                            </Overlay>
                        </Portal>
                    ) : (
                        <React.Fragment>
                            <AttachmentsInline {...props} />
                            {!isPreviewMode() && <InxToolTip id={tooltipComponentId} />}
                        </React.Fragment>
                    )
                }
            </ThemeProvider>
        </ErrorBoundary>
    );
}

